import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Product from './Product';
import DeliveryProcess from './DeliveryProcess';
import ErpSection from './ErpSection';
import IndustriesSection from './IndustiresSection';
import TechnologySection from './TechnologySection';
// import Contact from './Contact';
import ScrollToTopButton from './ScrollToTopButton';
const Home = () => {
  return (
    <div className="home-page">

      <main>
        <Header />
        <ErpSection/>
        <Hero />
          <Product/>
        <DeliveryProcess />
        <IndustriesSection/>
        <TechnologySection/>
        {/* <Contact/> */}
        <ScrollToTopButton/>
        
      </main>
    </div>
  );
};

export default Home;